import styled from 'styled-components';
import {
  AccordionPanel,
  AccordionHeader,
  AccordionItem,
} from '@fluentui/react-components';

import {
  PrimaryButton,
  SecondaryButton,
} from 'src/styles/globalStyles/buttonStyles.styled';
import { isMobile } from 'react-device-detect';

export const SkillsContainer = styled.div`
  background: ${(props) => props.theme.skillsAccordionBackground};
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;

  p {
    font-size: 14px;
  }
`;

export const MySkillsContainer = styled.div`
  background: ${(props) => props.theme.skillsAccordionBackground};
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-left: 32px;
  padding-right: 32px;
  padding-top: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid ${(props) => props.theme.skillsAccordionBorderColor};
`;

export const MySkillsList = styled.div`
  background: ${(props) => props.theme.skillsAccordionBackground};
  padding-left: 1rem;
  padding-right: 1rem;

  @media (max-width: 710px) {
    padding: 0;
  }
`;

export const MySkillsTitle = styled.h2`
  font-size: 16px;
  font-weight: ${isMobile ? 600 : 700};
`;

export const MySkillsHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  gap: 15%;
  @media (max-resolution: 100dpi) {
    gap: 150px;
    margin-right: 0;
    p {
      &:nth-child(2) {
        margin-right: 20px;
      }
    }
    p {
      &:nth-child(2) {
        margin-left: 15px;
      }
    }
  }
  p {
    &:nth-child(3) {
      margin-right: 16px;
    }
  }
`;

export const SkillBackground = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  padding-left: 40px;
  padding-right: 12px;
  padding-top: 6px;
  padding-bottom: 8px;
  margin: 0 11px;
  margin-left: -11px;
  border-bottom: 1px solid ${(props) => props.theme.skillsAccordionBorderColor};
  position: relative;
  gap: 12px;
  &:hover {
    background: ${(props) => props.theme.skillsAccordionOpenHeaderBackground};
    button {
      background: ${(props) => props.theme.skillsEditButtonBackground};
      color: ${(props) => props.theme.skillsEditButtonTextColor};
      border: 1px solid #d1d1d1;
    }
  }
  @media (max-width: 710px) {
    button {
      background: ${(props) => props.theme.skillsEditButtonBackground};
      color: ${(props) => props.theme.skillsEditButtonTextColor};
      border: 1px solid #d1d1d1;
    }
  }
`;

export const SkillItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 15%;
  p {
    &:nth-child(2) {
      width: 60px;
    }
  }
`;

export const SkillsItemHeader = styled.div`
  ${MySkillsHeader}
  padding: 0;
  width: 100%;
  gap: 10px;

  @media (max-width: 710px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;

export const SkillItemTitle = styled.p`
  font-size: 14px;
  width: 100%;
  color: ${(props) => props.theme.skillTitleColor};
  letter-spacing: 0.6px;

  @media (max-width: 710px) {
    font-size: 16px;
    font-weight: 400;
  }
`;

export const StyledAccordionPanel = styled(AccordionPanel)`
  width: 100%;
`;

export const StyledAccordionHeader = styled(AccordionHeader)<{
  isDarkTheme: boolean;
}>`
  p:nth-child(1) {
    margin-right: 18px;
  }
  p:nth-child(3) {
    margin-left: 18px;
  }
  ${({ isDarkTheme }) => {
    if (isDarkTheme) {
      return 'background: #242424;';
    } else {
      return 'background: #FFFFFF;';
    }
  }}
  h1 {
    font-weight: 600;
  }
  [aria-expanded='true'] {
    ${({ isDarkTheme }) => {
      if (isDarkTheme) {
        return 'background: #292929;';
      } else {
        return 'background: #F5F5F5;';
      }
    }}
  }
  &:hover {
    ${({ isDarkTheme }) => {
      if (isDarkTheme) {
        return 'background: #292929;';
      } else {
        return 'background: #F5F5F5;';
      }
    }}
    button {
      display: flex;
    }
  }
`;

export const EditButton = styled(SecondaryButton)<{ isMobile: boolean }>`
  color: ${(props) => props.theme.skillsEditButtonColor};
  border: none;
  width: 20px;
  gap: 12px;
  position: relative;
  svg {
    position: absolute;
    top: 50%;
    left: 35%;
    transform: translate(-50%, -50%);
  }
  p {
    margin-left: 20px;
  }
  &:hover {
    color: #242424;
    border: 1px solid #c7c7c7;
  }

  @media (max-width: 710px) {
    color: #242424;
    border: 1px solid #c7c7c7;
    height: 12px;
    width: 12px !important;
    padding: 6px;
    svg {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;

export const EditButtonMobile = styled.button`
  color: ${(props) => props.theme.skillsEditButtonColor};
  background: transparent;
  border: none;
  border-radius: 4px;
  margin-right: 2px;
  position: relative;

  border: 1px solid #c7c7c7;
  width: 26px;
  height: 26px;
  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

export const AddSkillButtonCategory = styled(PrimaryButton)`
  display: none;
  margin-left: auto;
  @media (max-width: 710px) {
    padding: 2px 0;
    width: 10px;
  }
`;

export const AddSkillButtonEmptyCategory = styled(AddSkillButtonCategory)`
  display: none;
  margin-left: auto;
  position: absolute;
  z-index: 10;
  top: 50%;
  right: 12px;
  transform: translate(0, -50%);
`;

export const MySkillsCategoryAccordion = styled(AccordionItem)`
  [aria-expanded='true'] {
    h1 {
      font-weight: 600;
    }
    button {
      display: flex;
    }
  }
  h1 {
    font-weight: 400;
  }
  width: 100%;
`;

export const MySkillsAccordionItem = styled(AccordionItem)`
  border-bottom: 1.5px solid #5b5fc7;
`;

export const EmptySkillsCategoryWrapper = styled.div`
  position: relative;
  &:hover {
    button {
      display: flex;
    }
  }
`;

export const CategoryColumnTitle = styled.p`
  font-size: 12px;
  font-weight: 600;
  width: 60%;

  @media (max-width: 710px) {
    font-size: 16px;
    font-weight: 600;
  }
`;

export const MySkillsListContainer = styled.div`
  height: 78.5vh;
  overflow: scroll;
  overflow-x: hidden;
  ::-webkit-scrollbar {
    width: 0px;
    background: transparent;
  }

  @media (max-width: 710px) {
    padding-bottom: 70px;
  }
  background: ${(props) => props.theme.skillsBackground};
`;

export const MySkillsMobileListContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
`;

export const MySkillsMobileLevelAndAttitude = styled.p`
  font-size: 13px;
  font-weight: 400;
  color: ${(props) => props.theme.skillLevelColor};
`;

export const MySkillsStatusIndicatorMobileWrapper = styled.div`
  position: absolute;
  left: 10px;
`;

export const AddSkillButtonCategoryMobile = styled.button`
  display: none;
  margin-left: auto;
  padding: 3px;
  border-radius: 4px;
  background: #5b5fc7;
  color: white;
`;

export const FindExpertButton = styled(PrimaryButton)<{
  findExpertPopup: boolean;
}>`
  position: fixed;
  bottom: 19px;
  right: 11px;
  z-index: 100;
  border-radius: 99px;
  font-size: 14px !important;
  font-weight: 600 !important;
  height: 48px;
  width: 89px;
  padding: 0 8px;
  ${({ findExpertPopup }) => {
    if (findExpertPopup) {
      return 'display: none;';
    } else {
      return 'display: flex;';
    }
  }};
`;

export const AddSkillButtonEmptyCategoryMobile = styled(
  AddSkillButtonCategoryMobile
)`
  display: none;
  margin-left: auto;
  position: absolute;
  z-index: 10;
  top: 50%;
  right: 12px;
  transform: translate(0, -50%);
`;
